import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from '@components/shared/ErrorBoundary';

/**
 * FullPageLayout - Layout for protected pages without the Sidebar
 */
export function FullPageLayout() {
  return (
    <div className="h-screen overflow-hidden flex bg-[--base-surface-1]">
      <main className="flex-1 overflow-y-auto">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
